export enum types {
	json = 'json',
	blob = 'blob',
	response = 'response'
}

export enum configEnum {
	get = 'GET',
	post = 'POST',
	put = 'PUT',
	delete = 'DELETE'
}

export type ConfigType = 'GET' | 'POST' | 'PUT' | 'DELETE'

